module.exports = __webpack_public_path__ + "img/resource-my-active.0cd16db5.png";